import { Shark, Utils } from "shark-mvc";

import templateContent from "./past-refuel.html";
import { vehicleManager } from "../../_shark_jaws/managers/vehicleManager";

import { refuelManager } from "../../_shark_jaws/managers/refuelManager";

var pastRefuelComponent = Shark.createJaw("pastRefuelComponent");
pastRefuelComponent.templateContent = templateContent;

pastRefuelComponent.addMethod("beforeLoad", function(){
	const vehicleList = Shark.get("vehicleList");
	if (vehicleList.length === 0) {
		vehicleManager.getList();
	}

	const pastRefuelList = Shark.get("pastRefuelList");
	if (pastRefuelList.length === 0) {
		refuelManager.getPastRefuel();
	}

});

pastRefuelComponent.addMethod("beforeRender", function () {
	const pastRefuelList = Shark.get("pastRefuelList");
	pastRefuelList.forEach(pastRefuel => {
		pastRefuel.vehicleData = Utils.safp(Shark.get("vehicleList"), "id", pastRefuel.vehicleId);
	});
});

pastRefuelComponent.addMethod("init", function () {
	Shark.set({
		vehicleList: Shark.get("vehicleList") || [],
		pastRefuelList: Shark.get("pastRefuelList") || []
	});
});

pastRefuelComponent.addMethod("refuelManager_pastRefuelListChangedHandler", function () {
	Shark.render();
});

pastRefuelComponent.addMethod("refuelManager_savedHandler", function () {
	refuelManager.getPastRefuel();
});

Shark.registerComponent(pastRefuelComponent);

export { pastRefuelComponent };
